/** PURE_IMPORTS_START .._.._Observable,.._.._operator_debounce PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { debounce } from '../../operator/debounce';
Observable.prototype.debounce = debounce;
//# sourceMappingURL=debounce.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/add/operator/debounce.js
// module id = 656
// module chunks = 0